export default __webpack_public_path__ + "static/media/MonthlyIcon.4a4ecaba.svg";